import { IApplicationState } from '../../../types/redux';

export function selectRegionId(state: IApplicationState) {
  return state.filters.jsonQuery.region?.value[0] ?? 4593;
}
